// import agent from "../agent";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
    MUSIC_SEARCH_LABEL_LOAD,
    MUSIC_SEARCH,
    MUSIC_SEARCH_PAGE_UNLOAD,
    MUSIC_SEARCH_LEFT,
    MUSIC_SEARCH_LABEL_LOAD_All,
    SHOW_TORT_POPUP,
} from "constants/actionTypes";
import { Input } from "antd";
import agent from "agent";
import MusicTable from "components/Music/comps/MusicTable";
import MusicStyle from "components/Music/LeftItems/Style";
import MusicInstruments from "components/Music/LeftItems/Instruments";
import MusicEmotion from "components/Music/LeftItems/Emotion";
import MusicScene from "components/Music/LeftItems/Scene";
import MusicLength from "components/Music/LeftItems/Length";
import MusicArea from "components/Music/LeftItems/Area";
import MusicVocal from "components/Music/LeftItems/Vocal";
import MusicSpeed from "components/Music/LeftItems/Speed";
import Loading from "components/Loading";
import { redirectTo, noShowPage } from "dispatch";
import Base64 from 'base-64';

import Tags from "components/Music/Tags";
import "./Search.less";
const queryString = require("query-string");
const jquery = require("jquery");

const mapStateToProps = state => ({
    ...state.musicSearch,
    pagination: state.musicTable.pagination,
    labelsData: state.labels.labelsData,
    labelsDataAll: state.labels.labelsDataAll,
});

let tags = {};

const mapDispatchToProps = dispatch => ({
    loadSearch: (pager, payload) => {
        return dispatch({ type: MUSIC_SEARCH, pager, payload });
    },
    unLoadSearch: () => {
        return dispatch({ type: MUSIC_SEARCH_PAGE_UNLOAD });
    },
    changeStatus: changes => {
        return dispatch({ type: MUSIC_SEARCH_LEFT, changes });
    },
    loadLabel: () => {
        return dispatch({
            type: MUSIC_SEARCH_LABEL_LOAD,
            payload: agent.Music.searchLabels(),
        });
    },
    loadLabelAll: () => {
        return dispatch({
            type: MUSIC_SEARCH_LABEL_LOAD_All,
            payload: agent.Music.searchLabelAlls(),
        });
    },
    showTortPopup: isTortShow => {
        return dispatch({ type: SHOW_TORT_POPUP, isTortShow });
    },
});

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: "style",
            keyword: "",
            stringified: "--",
            tag: {},
            subscribe: "",
            checkedVip: false,
            checkedFree: false,
            checkedMaterial: props.location.pathname === '/music/material' ? true : false,
            checkedSearchByKey: false,
            checkedSimilarSearch: false,
            similarAudioFile: null,
            similarSearchLoading: false,
            similarSearchData: null,
            naturalSearchLoading: false,
            naturalSearchData: null,
        };
        this.similarSearchRequestId = 0;
    }

    static propTypes = {
        isTortShow: PropTypes.shape({
            tortShow: PropTypes.bool.isRequired,
        }),
        loadSearch: PropTypes.func.isRequired,
        unLoadSearch: PropTypes.func.isRequired,
        changeStatus: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        total: PropTypes.number.isRequired,
        showTortPopup: PropTypes.func.isRequired,
    };

    componentWillUnmount() {
        this.props.unLoadSearch();
    }


    componentDidMount() {
        this.props.loadLabel();
        this.props.loadLabelAll();
        const query = queryString.parse(this.props.location.search);
        let param = '';
        let tiaoParams = {};
        if (query.tiao) {
            console.log(" 曲库类型" + Base64.decode(query.tiao));
            param = Base64.decode(query.tiao);
            tiaoParams = noShowPage.baseDecode(query.tiao);
            //let mykeyword=mykeyword.split("&");
            if (tiaoParams.keyword) {
                this.setState({ keyword: tiaoParams.keyword });
            }

            /*if(mykeyword.length>1)
            {
                mykeyword=mykeyword[0].split("=")[1];
                this.setState({keyword: decodeURIComponent(mykeyword)});
            }
        
            if (!this.state.keyword && query.keyword) {
                this.setState({ keyword: query.keyword });
            }*/
            this.setState({ checkedVip: (sessionStorage.getItem('checkboxvip') === "true") });
            this.setState({ checkedFree: (sessionStorage.getItem('checkedFree') === "true") });
            this.setState({ checkedMaterial: (sessionStorage.getItem('checkedMaterial') === "true") });
            if (param.indexOf('subscribe=') > -1) {
                //let subscribe=mykeyword.substring('subscribe='.length+1);
                let pos = param.indexOf('subscribe=') + 'subscribe='.length;
                let subscribe = param.substring(pos);
                if (subscribe == 'free')
                    this.setState({ checkedFree: true });
                if (subscribe == 'subscribe')
                    this.setState({ checkedVip: true });
                if (subscribe == 'material')
                    this.setState({ checkedMaterial: true });
                console.log("订阅类型=" + subscribe);
            }
            if (tiaoParams.naturalSearch == 1) {
                this.setState({
                    checkedSearchByKey: true,
                    checkedSimilarSearch: false,
                    checkedVip: false,
                    checkedFree: false,
                    checkedMaterial: false,
                    subscribe: "",
                    naturalSearchData: null,
                    similarAudioFile: null,
                    similarSearchData: null,
                    similarSearchLoading: false,
                }, () => this.runNaturalLanguageSearch(tiaoParams.keyword || this.state.keyword));
            }
            if (tiaoParams.similarSearch == 1) {
                this.setState({
                    checkedSearchByKey: false,
                    checkedSimilarSearch: true,
                    checkedVip: false,
                    checkedFree: false,
                    checkedMaterial: false,
                    subscribe: "",
                    naturalSearchData: null,
                    similarSearchData: null,
                    similarSearchLoading: false,
                });
            }
        }



    }

    componentDidUpdate(prevProps, prevState) {
        sessionStorage.setItem('checkboxvip', this.state.checkedVip);
        sessionStorage.setItem('checkedFree', this.state.checkedFree);
        sessionStorage.setItem('checkedMaterial', this.state.checkedMaterial);
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        const { location, pagination, loadSearch } = nextProps;
        const query = queryString.parse(location.search);
        let qu = {};
        if (query) {
            qu = noShowPage.baseDecode(query.tiao);
        }
        tags = {
            ...qu,
        }
        const page = qu && qu.page ? qu.page : 1;
        const params = {
            ...query,
            subscribe: prevState.subscribe,
            keyword: prevState.keyword,
            page,
        };
        if (location.pathname === '/music/material') {
            params.subscribe = 'material'
        }
        // delete query.page;
        const stringified = queryString.stringify(query);

        if (prevState.stringified != stringified && qu.naturalSearch != 1 && qu.similarSearch != 1) {
            const pager = { ...pagination };
            pager.current = parseInt(page);
            params.size = pagination.pageSize;
            loadSearch(pager, agent.Music.search(params));
        }

        return { stringified };
    }
    loadData(pager, params) {
        // do not
    }

    normalizeSearchPayload = payload => {
        if (Array.isArray(payload)) {
            return { audios: payload, total: payload.length };
        }
        const body = payload || {};
        const data = body.data;
        const audios =
            body.audios ||
            body.results ||
            (data && data.audios) ||
            (Array.isArray(data) ? data : []);
        const total =
            typeof body.total !== "undefined"
                ? body.total
                : data && typeof data.total !== "undefined"
                    ? data.total
                    : audios.length;
        return { ...body, audios, total };
    }

    runNaturalLanguageSearch = keyword => {
        const searchKeyword = keyword != null ? keyword : this.state.keyword;
        this.setState({ naturalSearchLoading: true });
        agent.Music.searchbylanguage(searchKeyword)
            .then(res => {
                const payload = res && res.body ? res.body : res;
                this.setState({
                    naturalSearchLoading: false,
                    naturalSearchData: this.normalizeSearchPayload(payload),
                });
            })
            .catch(err => {
                console.log("自然语言搜索错误", err);
                this.setState({
                    naturalSearchLoading: false,
                    naturalSearchData: { audios: [], total: 0 },
                });
            });
    }
    runSimilarMusicSearch = file => {
        if (!file) {
            this.setState({
                similarSearchLoading: false,
                similarSearchData: null,
            });
            return;
        }
        const requestId = this.similarSearchRequestId + 1;
        this.similarSearchRequestId = requestId;
        this.setState({
            similarSearchLoading: true,
            similarSearchData: null,
        });
        agent.Music.searchsimilar({ audio: file })
            .then(res => {
                if (requestId !== this.similarSearchRequestId) {
                    return;
                }
                const payload = res && res.body ? res.body : res;
                this.setState({
                    similarSearchLoading: false,
                    similarSearchData: this.normalizeSearchPayload(payload),
                });
            })
            .catch(err => {
                if (requestId !== this.similarSearchRequestId) {
                    return;
                }
                console.log("相似音乐搜索错误", err);
                this.setState({
                    similarSearchLoading: false,
                    similarSearchData: { audios: [], total: 0 },
                });
            });
    }

    handleKeywordSubmit = e => {
        e.preventDefault();
        if (this.state.checkedSearchByKey) {
            this.runNaturalLanguageSearch();
            return;
        }
        this.handleSearchClick("keyword", this.state.keyword);
        //埋点 用户搜索关键词提交到后台        
        jquery.ajax({
            url: agent.getApiUrl() + '/userdata/inssearchkw',
            data: { "keyword": this.state.keyword },
            success: function (data) {
                console.log("搜索成功");
            },
            error: function (err) {
                console.log("搜索错误 " + err);
            }
        });
    };
    handleSearchClick(search, value) {
        const { match } = this.props;
        const query = queryString.parse(this.props.location.search);
        let tiao = noShowPage.baseDecode(query.tiao);
        const params = {
            ...tiao,
            page: 1,
        };
        params[search] = value;
        const stringTiao = {
            tiao: noShowPage.baseEecode(params),
        }
        const stringified = queryString.stringify(stringTiao);
        //搜索关键词保存到服务器
        redirectTo({
            pathname: match.url,
            search: `?${stringified}`,
        });
    }
    handleResetClick(search) {
        this.handleSearchClick("subscribe", this.state.subscribe);
    }
    handleChangeClick(show) {
        window.scrollTo(0, 0);
        if (this.state.show == show) {
            this.setState({
                show: "",
            });
        } else {
            this.setState({
                show: show,
            });
        }
    }
    handleKeywordChange = e => {
        this.setState({ keyword: e.target.value });
    };
    handleCheckBoxChange = e => {
        let subscribe = "";

        if (e.target.checked) {
            if (e.target.value == "vip") {
                subscribe = "subscribe"
            } else if (e.target.value == "free") {
                subscribe = "free"
            } else {
                subscribe = "material"
            }

            this.setState({
                checkedVip: e.target.value == "vip" ? e.target.checked : !e.target.checked,
                checkedFree: e.target.value == "free" ? e.target.checked : !e.target.checked,
                checkedMaterial: e.target.value == "material" ? e.target.checked : !e.target.checked,
                subscribe: "subscribe",
            })
        } else {
            subscribe = "";
            this.setState({
                checkedVip: false,
                checkedFree: false,
                checkedMaterial: false,
                subscribe: ""
            })
        }
        this.handleSearchClick("subscribe", subscribe);
    }
    handleSearchByKeyChange = e => {
        const checkedSearchByKey = e.target.checked;

        this.setState({
            checkedSearchByKey,
            checkedSimilarSearch: checkedSearchByKey ? false : this.state.checkedSimilarSearch,
            checkedVip: checkedSearchByKey ? false : this.state.checkedVip,
            checkedFree: checkedSearchByKey ? false : this.state.checkedFree,
            checkedMaterial: checkedSearchByKey ? false : this.state.checkedMaterial,
            subscribe: checkedSearchByKey ? "" : this.state.subscribe,
            similarAudioFile: checkedSearchByKey ? null : this.state.similarAudioFile,
            similarSearchData: checkedSearchByKey ? null : this.state.similarSearchData,
            similarSearchLoading: checkedSearchByKey ? false : this.state.similarSearchLoading,
        });

        if (checkedSearchByKey) {
            this.setState({ naturalSearchData: null });
        }
    }
    handleSimilarSearchChange = e => {
        const checkedSimilarSearch = e.target.checked;

        this.setState({
            checkedSimilarSearch,
            checkedSearchByKey: checkedSimilarSearch ? false : this.state.checkedSearchByKey,
            checkedVip: checkedSimilarSearch ? false : this.state.checkedVip,
            checkedFree: checkedSimilarSearch ? false : this.state.checkedFree,
            checkedMaterial: checkedSimilarSearch ? false : this.state.checkedMaterial,
            subscribe: checkedSimilarSearch ? "" : this.state.subscribe,
            naturalSearchData: checkedSimilarSearch ? null : this.state.naturalSearchData,
            similarAudioFile: checkedSimilarSearch ? this.state.similarAudioFile : null,
            similarSearchData: checkedSimilarSearch ? this.state.similarSearchData : null,
            similarSearchLoading: checkedSimilarSearch ? this.state.similarSearchLoading : false,
        });
    }
    handleSimilarAudioFileChange = e => {
        const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
        this.setState({
            similarAudioFile: file,
            similarSearchData: null,
        });
        this.runSimilarMusicSearch(file);
        e.target.value = "";
    }
    callBackTort() {
        const { isTortShow, showTortPopup } = this.props;
        const send = {
            ...isTortShow,
            tortShow: true,
        };
        showTortPopup(send);
    }
    render() {
        const { location, match, labelsData } = this.props;
        const {
            show,
            keyword,
            checkedSearchByKey,
            checkedSimilarSearch,
            similarAudioFile,
            similarSearchData,
            similarSearchLoading,
            naturalSearchData,
            naturalSearchLoading,
        } = this.state;
        const labelProps = {
            handleSearchClick: this.handleSearchClick.bind(this),
            handleResetClick: this.handleSearchClick.bind(this),
            handleChangeClick: this.handleChangeClick.bind(this),
            show: show,
            ...labelsData,
        };


        var tmpstr = document.location.toString();

        tmpstr = tmpstr.split("?");
        var source = { source: 0 };

        if (tmpstr.length > 1) {
            var param = tmpstr[1];
            source.source = param.split("=")[1];
            sessionStorage.setItem("source", param.split("=")[1]);
            if (tmpstr[1].indexOf("source=ip") > -1) {
                sessionStorage.setItem("source", "ip");
                console.log("来自IP");
            }

        }


        if (!labelsData) {

            return (
                <Loading />
            )
        }
        return (

            <div className="mainContents" id="search_less">
                <div className="mainBoxWrapper">
                    <div className="sideBox">
                        <div className="accordionWrapper is-open">
                            <p className="accordionWrapper__title">
                                <em>标签</em>
                                搜索
                            </p>
                            <div className="accordionWrapper__contents">
                                <MusicStyle {...this.props} {...labelProps} />
                                <MusicInstruments
                                    {...this.props}
                                    {...labelProps}
                                />
                                <MusicEmotion {...this.props} {...labelProps} />
                                <MusicScene {...this.props} {...labelProps} />
                                <MusicLength {...this.props} {...labelProps} />
                                <MusicArea {...this.props} {...labelProps} />
                                <MusicVocal {...this.props} {...labelProps} />
                                <MusicSpeed {...this.props} {...labelProps} />
                            </div>
                        </div>
                    </div>

                    <div className="mainBox">
                        <div className="searchBox">
                            <form onSubmit={this.handleKeywordSubmit}>
                                <input
                                    type="text"
                                    name=""
                                    value={keyword}
                                    className="searchSkin"
                                    onChange={this.handleKeywordChange}
                                    placeholder="您可以搜索：用途、情绪、风格、乐器、创作家……"
                                />
                                <input
                                    type="submit"
                                    name="submit"
                                    value="搜寻"
                                    id="searchSubmit"
                                />
                            </form>
                        </div>

                        <div className="resultContents">
                            <div style={{ overflow: "hidden" }}>
                                <div className="searchFilterOptions">
                                    <label className="u-checkbox2 searchFilterOption naturalSearchDiv" style={{ lineHeight: "42px" }}>
                                        <Input
                                            type="checkbox"
                                            value="searchbykey"
                                            id="checkboxsearchbykey"
                                            checked={checkedSearchByKey}
                                            onChange={this.handleSearchByKeyChange}
                                        />
                                        <span style={{ color: "#339e9d", fontWeight: "600" }}>
                                            AI自然语言搜索
                                        </span>
                                    </label>
                                    <label className="u-checkbox2 searchFilterOption similarSearchDiv" style={{ lineHeight: "42px" }}>
                                        <Input
                                            type="checkbox"
                                            value="similarsearch"
                                            id="checkboxsimilarsearch"
                                            checked={checkedSimilarSearch}
                                            onChange={this.handleSimilarSearchChange}
                                        />
                                        <span style={{ color: "#339e9d", fontWeight: "600" }}>
                                            AI相似音乐
                                        </span>
                                    </label>

                                    {!checkedSearchByKey && !checkedSimilarSearch && (
                                        <React.Fragment>
                                            <label className="u-checkbox2 searchFilterOption" style={{ lineHeight: "42px" }}>
                                                <Input type="checkbox" value="vip" id="checkboxvip" checked={this.state.checkedVip} onChange={this.handleCheckBoxChange} />
                                                <span style={{ color: "rgb(207,152,35)", fontWeight: '600' }}>
                                                    金V曲库
                                                </span>
                                            </label>

                                            <label className="u-checkbox2 searchFilterOption freeDiv" style={{ lineHeight: "42px" }}>
                                                <Input type="checkbox" value="free" id="checkboxfree" checked={this.state.checkedFree} onChange={this.handleCheckBoxChange} />
                                                <span style={{ color: "#9A0000", fontWeight: '600' }}>
                                                    免费曲库
                                                </span>
                                            </label>
                                            <label className="u-checkbox2 searchFilterOption materialDiv" style={{ lineHeight: "42px" }}>
                                                <Input type="checkbox" value="material" id="checkboxmaterial" checked={this.state.checkedMaterial} onChange={this.handleCheckBoxChange} />
                                                <span style={{ color: "#336633", fontWeight: '600' }}>
                                                    音效素材
                                                </span>
                                            </label>
                                        </React.Fragment>
                                    )}
                                </div>

                                <div className="sty">
                                    <a href="javascript:;" className="callBackTort " onClick={this.callBackTort.bind(this)}>
                                        反馈侵权
                                    </a>
                                </div>
                            </div>
                            <div style={{ overflow: "hidden" }}>
                                <Tags search={tags} handleSearchClick={this.handleSearchClick.bind(this)} handleResetClick={this.handleResetClick.bind(this)} />
                            </div>
                            {checkedSimilarSearch && (
                                <div className="similarSearchUpload">
                                    <label className="similarSearchUpload__button">
                                        <input
                                            type="file"
                                            accept="audio/*"
                                            onChange={this.handleSimilarAudioFileChange}
                                        />
                                        <span>选择上传音乐文件</span>
                                    </label>
                                    {similarSearchLoading ? (
                                        <p className="similarSearchUpload__file">
                                            正在上传并搜索相似音乐，请稍候...
                                        </p>
                                    ) : similarAudioFile && (
                                        <p className="similarSearchUpload__file">
                                            已选择：{similarAudioFile.name}
                                        </p>
                                    )}
                                </div>
                            )}
                            {checkedSearchByKey ? (
                                <MusicTable
                                    loadData={this.loadData.bind(this)}
                                    location={location}
                                    match={match}
                                    tableData={naturalSearchData ? naturalSearchData.audios : []}
                                    pagination={{ pageSize: 10, current: 1, total: naturalSearchData ? naturalSearchData.total : 0 }}
                                    disableAutoLoad={true}
                                    hidePagination={true}
                                    loading={naturalSearchLoading}
                                    emptyText="未找到符合这段自然语言描述的音乐，请换一种说法再试。"
                                />
                            ) : checkedSimilarSearch ? (
                                <MusicTable
                                    loadData={this.loadData.bind(this)}
                                    location={location}
                                    match={match}
                                    tableData={similarSearchData ? similarSearchData.audios : []}
                                    pagination={{ pageSize: 10, current: 1, total: similarSearchData ? similarSearchData.total : 0 }}
                                    disableAutoLoad={true}
                                    hidePagination={true}
                                    loading={similarSearchLoading}
                                    emptyText="未找到相似音乐，请更换音乐文件再试。"
                                />
                            ) : (
                                <MusicTable
                                    loadData={this.loadData.bind(this)}
                                    location={location}
                                    match={match}
                                />
                            )}
                        </div>

                        <div className="bnrArea01 hidden">
                            <h2 className="bnrArea01__title">优惠折扣</h2>
                            <div
                                className="m-columnBox"
                                data-column="1"
                                data-column-sp="1"
                            >
                                <ul className="m-columnBox__items">
                                    <li className="m-columnBox__item">
                                        <a href="">
                                            <img
                                                src="/assets/img/bnr_dmy.jpg"
                                                alt=""
                                            />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Search);
